module.exports = __webpack_public_path__ + "static/img/icon-sqdb.37b2f027.png";